import React from 'react';
import { Button, Tooltip, Popconfirm } from 'antd';

/**
 * Quiet icon-only action for tables and cards (view / edit / delete …), always with a tooltip.
 * Pass `confirm` ({ title, description, okText }) to require confirmation (e.g. deletes).
 */
export default function IconAction({ icon, label, onClick, danger = false, disabled = false, loading = false, confirm, href, target }) {
    const button = (
        <Button
            type="text"
            size="small"
            icon={icon}
            danger={danger}
            disabled={disabled}
            loading={loading}
            href={href}
            target={target}
            aria-label={label}
            onClick={confirm ? (e) => e.stopPropagation() : onClick}
        />
    );
    if (confirm) {
        return (
            <Popconfirm
                title={confirm.title}
                description={confirm.description}
                okText={confirm.okText || 'Confirmar'}
                cancelText={confirm.cancelText || 'Cancelar'}
                okButtonProps={{ danger }}
                onConfirm={onClick}
                disabled={disabled}>
                <Tooltip title={label}>{button}</Tooltip>
            </Popconfirm>
        );
    }
    return <Tooltip title={label}>{button}</Tooltip>;
}

/** Horizontal group of IconActions. */
export function IconActions({ children }) {
    return <div className="flex items-center justify-end gap-0.5">{children}</div>;
}
